import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
} from "@mui/material";

import { useMemo } from "react";

import RoomSlotsSection from "./RoomSlotsSection";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useBszFinderContext } from "../../context/bszContext";
import useBszActions from "../../hooks/useBszActions";
import bszService from "../../services";

export default function RoomDialog({ room, onClose }) {
  const { currentUser } = useAppContext();
  const { isBszAdmin, rooms, serverNow } = useBszFinderContext();
  const { showSnackbar } = useBszActions();
  /**
   * ✅ DERIVE FULL ROOM
   */
  const fullRoom = useMemo(() => {
    if (!room) return null;
    return rooms.find((r) => r.id === room.id) || room;
  }, [room, rooms]);

  /**
   * ✅ RESERVE SLOT
   */
  const handleReserve = async (slotId, slot) => {
    if (!currentUser) return;

    const isMine = slot?.reservedBy?.id === currentUser.id;
    const isReserved = !!slot?.reservedBy;
    const isAdmin = isBszAdmin;

    let action;

    if (isMine) action = "remove";
    else if (isAdmin && isReserved) action = "override";
    else action = "reserve";

    if (isAdmin && isReserved && !isMine) {
      const confirmed = window.confirm(
        `Willst du ${slot.reservedBy?.name} wirklich ersetzen?`,
      );
      if (!confirmed) return;
    }

    try {
      await bszService.reserveSlot(slotId, action);

      if (action === "override") {
        showSnackbar(`Du hast ${slot.reservedBy?.name} ersetzt`);
      }
    } catch (err) {
      console.error("❌ reserve failed:", err);
    }
  };

  /**
   * ✅ RENDER
   */
  if (!fullRoom) return null;

  const studentFree = fullRoom.studentSlots?.filter(
    (s) => !s.reservedBy,
  ).length;

  return (
    <Dialog open={!!room} onClose={onClose} fullWidth maxWidth="sm">
      {/* ✅ HEADER */}
      <DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="h6">{fullRoom.name}</Typography>

          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            {studentFree} frei
          </Typography>
        </Box>
      </DialogTitle>

      {/* ✅ CONTENT */}
      <DialogContent>
        <RoomSlotsSection
          title="Arbeitsplätze Lernende"
          slots={fullRoom.studentSlots}
          type="student"
          onReserve={handleReserve}
          serverNow={serverNow}
        />

        <RoomSlotsSection
          title="Arbeitsplätze Lehrpersonen"
          slots={fullRoom.teacherSlots}
          type="teacher"
          onReserve={handleReserve}
          serverNow={serverNow}
        />
      </DialogContent>
    </Dialog>
  );
}
